const ManageCMS = () => {};
export default ManageCMS;
